const DEFAULT_COUNTRY = 'GB'
const DEFAULT_LANGUAGE = 'en'

export type FallbackContent = {
  close?: string
  title: string
  subTitle: string
  timelineHeader: string
  timelineItems: {
    title: string
    description: string
  }[]
}

export async function getFallbackContent(country: string, language: string): Promise<FallbackContent> {
  return import(`./content/${country?.toUpperCase()}.ts`)
    .then(c => {
      const content = c.default[language.toLowerCase()]
      if (!content) throw Error('Fallback content not found for language')
      return content
    })
    .catch(() => import(`./content/${DEFAULT_COUNTRY}.ts`).then(c => c.default[DEFAULT_LANGUAGE]))
}
